
<template>
  <div
    v-if="tabDatas"
    class="tabs"
  >
    <!-- tab 切换 -->
    <ul
      ref="tabNavParent"
      class="nav-bar clearfix"
    >
      <template v-for="(item) in tabDatas">
        <li
          v-show="item.show"
          :key="item.fieldkey"
          :class="{'active': item.fieldkey === selected}"
          @click="tabNavChange(item.fieldkey, $event)"
        >
          {{ item.fieldname }}
        </li>
      </template>
    </ul>
    <!-- form 表单 以及 评论，回访，变更历史等-->
    <keep-alive>
      <component
        :is="tabDatas[selected].component"
        v-if="tabDatas[selected]"
        ref="content"
        :data="tabDatas[selected].data"
        class="module"
      />
    </keep-alive>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import TabNav from '@/components/pc/TabNav'
import MyForm from './Form'
import InforFrom from './InforFrom'
import ReturnVisite from './ReturnVisite'
import CommentContent from './CommentContent'
import ChangeHistory from './ChangHistory/List'

export default {
  components: {
    TabNav,
    MyForm,
    ReturnVisite,
    CommentContent,
    ChangeHistory
  },
  props: {
    formData: {
      type: Object,
      default: () => { }
    }
    /* detailData: {
      type: Object,
      default: () => { }
    } */
  },
  data () {
    return {
      selected: this.$route.query.tab1 || 'baseDetail'
    }
  },
  computed: {
    ...mapGetters('inquery/detailData', ['permissionInfo']),
    from () { // all, my, audit, checkrepeat
      if (this.$route.name === 'InqueryCreate') { // 录入信息
        return 'input'
      } else { // 信息详情
        return this.$route.query.from
      }
    },
    tabDatas () {
      if (!this.formData || !this.permissionInfo) return
      let { formData = {} } = this
      delete formData.from_info
      delete formData.reception_info
      delete formData.audit_info
      delete formData.info
      for (let k in formData) {
        if (!formData[k].child || !formData[k].child.length) {
          delete formData[k]
        }
      }

      let data = {
        baseDetail: {
          fieldkey: 'baseDetail',
          fieldname: this.$t('message["1378"]'),
          component: MyForm,
          data: formData,
          show: this.permissionInfo.is_show_inquirydetail === 1
        },
        inforFrom: {
          fieldkey: 'inforFrom',
          fieldname: this.$t('message["583"]'),
          component: InforFrom,
          show: this.permissionInfo.is_show_fromdetail === 1
        },
        changeHistory: {
          fieldkey: 'changeHistory',
          fieldname: this.$t('message["48"]'),
          component: ChangeHistory,
          show: this.permissionInfo.is_show_historys === 1
        }
      }
      return data
    }
  },
  /* watch: {
    formData: {
      handler (val) {
        const { base_info: baseInfo = {} } = val || {}
        if (!baseInfo || !baseInfo.child || !val.deal_info) return

        for (let i in val) {
          let item = val[i]
          if (item.child && item.child.length) {
            this.$set(item, 'show', true)
          }
        }

        const infoStatus = baseInfo.child.find(
          item => item.fieldkey === 'info_status'
        )

        if (!infoStatus || !infoStatus.options) return

        const dealStatusItem = infoStatus.options.find(
          item => item.name === this.$t('message["109"]')
        ) || {}
        const res = dealStatusItem.id === infoStatus.fieldvalue

        this.$set(val.deal_info, 'show', res)
      },
      immediate: true
    }
  }, */
  mounted () {
    // this.$nextTick(() => {
    this.setNavStyle()
    // })
  },
  methods: {
    tabNavChange (k, ev) {
      this.selected = k

      this.setNavStyle()
      let $navBar = document.querySelector('.container-left .nav-bar')
      $navBar && ($navBar.style.borderBottom = 'none')
      this.$router.replace({
        query: {
          ...this.$route.query,
          tab1: k
        }
      })
      /* if (this.$getScrollTop() > this.$refs.content.$el.offsetTop) {
        window.scrollTo(0, this.$refs.content && this.$refs.content.$el.offsetTop)
      } */
    },
    setNavStyle () {
      let $containerScroll = document.querySelector('.container-left .containerScroll')
      let $navBar = document.querySelector('.container-left .nav-bar')

      $containerScroll && $containerScroll.addEventListener('scroll', () => {
        const scrollTop = $containerScroll.scrollTop
        if ($navBar && $containerScroll && scrollTop > 0) {
          $navBar.style.borderBottom = 'solid 1px #ebebeb'
        } else {
          $navBar.style.borderBottom = 'none'
        }
      }, false)
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  position: relative;
  height: 100%;
  padding-top: 48px;
  .nav-bar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 48px;
    background-color: #fff;
    li {
      position: relative;
      float: left;
      margin-right: 24px;
      height: 47px;
      line-height: 47px;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      &.active {
        color: $primary-color;
        border-bottom: solid 2px $primary-color;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  ::v-deep .nav-wrap {
    overflow: initial;
  }
  ::v-deep .nav-bar {
    margin-right: -40px;
    // border-bottom: solid 1px #ebebeb;
    li {
      position: relative;
      top: 1px;
    }
  }
  .history-module.containerScroll, .from-module.containerScroll {
    margin-right: -40px;
    padding: 24px 0;
    padding-right: 40px;
    height: 100%;
    overflow-y: scroll;
  }
}
</style>
